var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{staticClass:"modal-overlay",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-content"},[_c('img',{staticClass:"large-image",attrs:{"src":_vm.largeSrc,"alt":"Large Image"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }